const ENV = require('./env').default;

const getSettings = (env = '') => {
  return ENV.staging;
};

export default getSettings;
